
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage'; // Import LoginPage
import SignupPage from './pages/SignupPage'; // Import SignupPage
import ChangePasswordPage from './pages/ChangePasswordPage'; // Import ChangePasswordPage
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ProtectedRoute from './components/ProtectedRoute'; // Import ProtectedRoute
import JobDetailsPage from './pages/JobDetailsPage'; // Import JobDetailsPage
import { ConfigProvider } from './context/ConfigContext'; // Import ConfigProvider
import { loadDemoMode } from './utils/demoMode';
import './firebase'; // Initialize Firebase

function App() {
  const [demoMode, setDemoMode] = useState(null);
  useEffect(() => { loadDemoMode().then(setDemoMode); }, []);
  const isDevEnvironment = process.env.REACT_APP_FIREBASE_PROJECT_ID === 'loope-dev-env';

  return (
    <Router>
      <div className="min-h-screen bg-sky-100">
        {/* Demo Mode Banner */}
        {demoMode === true && (
          <div className="bg-orange-500 text-white text-center py-2 px-4 text-sm font-bold sticky top-0 z-50 shadow-md">
            🎭 DEMO MODE — Connected to demo database. Data is not real.
          </div>
        )}
        {/* Dev Environment Banner */}
        {isDevEnvironment && demoMode !== true && (
          <div className="bg-yellow-500 text-white text-center py-1 px-4 text-sm font-medium sticky top-0 z-50 shadow-md">
            🧪 TEST ENVIRONMENT - Development Mode
          </div>
        )}
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route 
            path="/change-password" 
            element={
              <ProtectedRoute>
                <ChangePasswordPage />
              </ProtectedRoute>
            } 
          />
          {/* Wrap protected routes that need config */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ConfigProvider> {/* Wrap Home */}
                  <Home />
                </ConfigProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/job/:jobId"
            element={
              <ProtectedRoute>
                <ConfigProvider> {/* Wrap JobDetailsPage */}
                  <JobDetailsPage />
                </ConfigProvider>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
